<template>
    <div class="container-picker" v-if="!isHidden">
        <v-date-picker
                range
                v-model="date"
                locale="pt-br"
                color="#7ABA1E"
                selectedItemsText="{0} selecionados"       
        >
            <button class="v-picker__submit" @click="dateSelected(date)">Aplicar</button>
        </v-date-picker>
    </div>
</template>

<script>
    export default {
        data: () => ({
            isHidden: false,
            date: null,
        }),
        emits: ['date-selected'],
        methods: {
            dateSelected(date) {

                this.isHidden = true;

                if (date.length === 2) {
                    let dateStart = new Date(date[0]).toISOString().substr(0, 10);
                    let dateEnd = new Date(date[1]).toISOString().substr(0, 10);

                    if (dateStart > dateEnd) {
                        date = [dateEnd, dateStart]
                    }

                    this.$emit('date-selected', date);
                } else {
                    this.$emit('date-selected', date);
                }
            },
            
        }
  
    }
</script>

<style lang="scss" scoped>
    

    .container-picker {
       


        position: relative;
        max-width: 290px;

        .icon-close {
            background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNi4yMTQyIDMuNzg1NzVDMTYuNTM5NyA0LjExMTE4IDE2LjUzOTcgNC42Mzg4MiAxNi4yMTQyIDQuOTY0MjZMNC45NjQyMiAxNi4yMTQzQzQuNjM4NzggMTYuNTM5NyA0LjExMTE0IDE2LjUzOTcgMy43ODU3IDE2LjIxNDNDMy40NjAyNyAxNS44ODg4IDMuNDYwMjcgMTUuMzYxMiAzLjc4NTcgMTUuMDM1N0wxNS4wMzU3IDMuNzg1NzVDMTUuMzYxMSAzLjQ2MDMxIDE1Ljg4ODggMy40NjAzMSAxNi4yMTQyIDMuNzg1NzVaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMuNzg1NyAzLjc4NTc1QzQuMTExMTQgMy40NjAzMSA0LjYzODc4IDMuNDYwMzEgNC45NjQyMiAzLjc4NTc1TDE2LjIxNDIgMTUuMDM1N0MxNi41Mzk3IDE1LjM2MTIgMTYuNTM5NyAxNS44ODg4IDE2LjIxNDIgMTYuMjE0M0MxNS44ODg4IDE2LjUzOTcgMTUuMzYxMSAxNi41Mzk3IDE1LjAzNTcgMTYuMjE0M0wzLjc4NTcgNC45NjQyNkMzLjQ2MDI3IDQuNjM4ODIgMy40NjAyNyA0LjExMTE4IDMuNzg1NyAzLjc4NTc1WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==) center no-repeat;
            background-size: 100%;
            width: 20px;
            height: 20px;
            position: absolute;
            left: 265px;
            top: 5px;
            z-index: 999;
        }
    }
    .v-picker {
        position: absolute !important;
        z-index: 9;
        box-shadow: 0 7px 20px -6px rgba(0, 0, 0, 0.5);
        max-width: 290px !important;

        &__body {
            width: 100% !important;
        }
    }
    .v-picker__submit {
        background: #7ABA1E;
        color: #FFF;
        font-weight: 600;
        text-transform: uppercase;
        padding: 3px 10px;
        margin-left: auto;
        border-radius: 5px;
    }
    
</style>